import { render, staticRenderFns } from "./OpenVPNServerList.vue?vue&type=template&id=2b2eaede&"
import script from "./OpenVPNServerList.vue?vue&type=script&lang=js&"
export * from "./OpenVPNServerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports